import { SquareHalfIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const UploadCsv = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <SquareHalfIcon size={Sizes[size]} color={fill} {...rest} />;
};

UploadCsv.displayName = 'UploadCsv';
